module.exports = __webpack_public_path__ + "slikacrna2.5d4472945fdeb8709400.png";